<tui-loader
  [inheritColor]="true"
  [overlay]="true"
  [showLoader]="(loading$ | async) ?? false"
>
  <div class="min-w-[430px] p-6">
    <h2
      class="text-xl text-center font-bold leading-tight tracking-tight text-gray-900 md:text-2xl"
    >
      {{ 'route.name.registration' | transloco }}
    </h2>
    <div class="flex flex-col gap-y-2 my-6">
      <tui-input [formControl]="form.controls.lastName" tuiTextfieldSize="l">{{
        'user.lastName' | transloco
      }}</tui-input>
      <tui-input [formControl]="form.controls.firstName" tuiTextfieldSize="l">{{
        'user.firstName' | transloco
      }}</tui-input>
      <tui-input
        [formControl]="form.controls.middleName"
        tuiTextfieldSize="l"
        >{{ 'user.middleName' | transloco }}</tui-input
      >
      <tui-input-password
        [formControl]="form.controls.password"
        tuiTextfieldSize="l"
        >{{ 'auth.password' | transloco }}</tui-input-password
      >
      <tui-input-password
        [formControl]="form.controls.passwordConfirm"
        tuiTextfieldSize="l"
        >{{ 'auth.confirmPassword' | transloco }}</tui-input-password
      >
    </div>
    <button
      (click)="register$.next()"
      [disabled]="!form.valid"
      class="w-full"
      tuiButton
      appearance="primary"
    >
      {{ 'auth.register' | transloco }}
    </button>
  </div>
</tui-loader>
